import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ICareMap } from '../caremap/ICareMap';
import { CareMapState } from '../caremap/CareMapState';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { useSubscription } from '@meraki-internal/state';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { MemberAvatar } from '../household/MemberAvatar';
import { formatAge } from '../utils/format';
import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { EditPatientNudgeBanner } from '../household/patient/EditPatientNudgeBanner';
import { EditPatientDrawer } from '../household/patient/EditPatientDrawer';
import { QuickAddButtons } from './QuickAddButtons';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';

export const ActiveCareRecipientActionsCard: React.FC = () => {
    const caremapState = useInstance(CareMapState);
    const history = useInstance(HistoryViewModel);
    const mixpanel = useInstance(MixPanelEventEmitter);

    useSubscription(() => caremapState);

    const caremap = caremapState.getActiveCaremap() as ICareMap;

    const editPatientDrawer = useInstance(EditPatientDrawer);

    if (!caremap){
        return null;
    }

    const gotoCare = () => {
        history.push(`/care/${caremap.careMapId}`);

        mixpanel.track('Care Page Opened', () => ({
            'Opened From': 'Caregiver Widget'
        }));
    };

    const onEdit = () => {
        editPatientDrawer.open();
    };

    const dataProps = {
        'data-type': 'care-actions',
        'data-caremap-id': `${caremap.userId}/${caremap.careMapId}`
    };

    return (
        <Card dataProps={dataProps} padded>
            <div>
                <div data-type="care-recipient" style={{ display: 'flex', alignItems: 'start', gap: 20, cursor: 'pointer' }} onClick={gotoCare}>

                    <MemberAvatar member={caremap.patient} />

                    <div style={{ display: 'flex', flexGrow: 1, flexDirection: 'column', gap: 10 }}>
                        <Text type="title" data-type="title">{caremap.patient.firstName || ''} {caremap.patient.lastName || ''}</Text>
                        <Text type="subtitle" data-type="subtitle">{formatAge(caremap.patient.dob)}</Text>
                    </div>
                </div>

                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <EditPatientNudgeBanner
                                canEdit
                                patient={caremap.patient}
                                onEdit={onEdit}
                            />
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <QuickAddButtons trackingFrom="Caregiver Widget" />
            </div>
        </Card>
    );
};
